export default __webpack_public_path__ + "static/media/damask.fa316da4.jpg";